import {
  Exclude, Expose, Transform, Type,
} from 'class-transformer';
import moment from 'moment';
import { SortDir } from 'pages/search/results/sort-dir.enum';
import { AppConstants } from 'constants/app-constants.enum';
import { SearchAnimal } from './search-animal';

@Exclude()
export class SearchResponse {
  @Expose()
  @Transform((value) => moment(value).format(AppConstants.CalendarDateFormat))
  analysisDate: string;

  @Expose()
  totalCount: number;

  @Expose()
  sortBy: string;

  @Expose()
  sortDir: SortDir;

  @Expose()
  @Type(() => SearchAnimal)
  results: SearchAnimal[];
}
